var render = function render(){var _vm=this,_c=_vm._self._c;return _c(require(`Svgs/${_vm.name}.svg?inline`),_vm._b({tag:"Component",staticClass:"SvgLoader",on:{"v-on":_vm.$listeners}},'Component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }